import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {
    TextField,
    FormControl
} from '@material-ui/core';
import { OrangeRadio } from '../NewProduct/styles';
import Back from '@material-ui/icons/KeyboardBackspace';
import { required } from './validator';
import { toast } from 'react-toastify';
import Hidden from '@material-ui/core/Hidden';
import Cancel from '@material-ui/icons/Clear';

class Source1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radioSource: '',
        }
    }

    onChangeRadio = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    returnToStartMaking = () => {
        this.props.returnTo({
            helpMeSource: true,
            newProduct: false,
            withGembah: false,
            finishedProducts: false
        });
    }

    nextScreen = () => {
        if (required(this.state.radioSource, 'Option')) {
            return toast.error(required(this.state.radioSource, 'Option'))
        }
        
        if (this.state.radioSource === 'YES') {
            this.props.goTo({
                helpMeSource: false,
                newProduct: false,
                withGembah: true,
                finishedProducts: false
            });
        }
        else if (this.state.radioSource === 'NO') {
            this.props.goTo({
                helpMeSource: false,
                newProduct: true,
                withGembah: false,
                finishedProducts: false
            });
        } else {
            toast.error('Choose a valid option');
        }
    }

    render() {
        const {
            radioSource
        } = this.state
        return(
            <Grid container>
                <Grid item xs={12} className="grayBg p-lr-5 p-tb-2 ">
                    <span className="cancel" onClick={this.returnToStartMaking}><Back/></span>
                    <Hidden smUp>
                    <span className="floatRight"><Cancel onClick={this.props.closeAll} className="cancel" /></span>
                    </Hidden>
                    <div className="m-tb-5">
                    <h3 className="m-tb-2 textCenter">Help me Source</h3>
                    <p className="p-lr-5 m-t-2">Find a factory to make your product.</p>
                    <div className=" p-lr-5">
                        <FormControl className="loginForm m-t-2">
                            <OrangeRadio
                                value="YES"
                                onChange={ e => this.onChangeRadio(e) }
                                checked= { radioSource === 'YES'}
                                name="radioSource"
                            />
                            <p className="inlineBlock relative " style={{'top':'2px'}}><span className="bold">Yes</span>, I have manufactured this before</p>
                        </FormControl>
                        <FormControl className="loginForm m-t-2">
                            <OrangeRadio
                                value="NO"
                                onChange={ e => this.onChangeRadio(e) }
                                checked= { radioSource === 'NO'}
                                name="radioSource"
                            />
                            <p className="inlineBlock relative " style={{'top':'2px'}}><span className="bold">No</span>, I have not manufactured this before</p>
                        </FormControl>
                        <FormControl className="loginForm m-t-2 ">
                            <TextField
                                type="submit"
                                className="yellowSubmit"
                                variant="outlined"
                                value="NEXT"
                                onClick={this.nextScreen}
                            />
                        </FormControl>
                    </div>
                    </div>
                 
                </Grid>
            </Grid>
        );
    };
};

export default Source1;